import React, { useEffect, useState, useRef } from "react";
import { ContextProviderComponent } from "./Context.js";
import { graphql } from "gatsby";
import styled from "styled-components";
import GlobalStyle from "styles/globalStyles.js";

import Loader from "components/global/Loader.js";

const MainWrapper = styled.div`
  position: relative;
`;

const Index = ({ data, children, pageContext }) => {
  return (
    <>
      <ContextProviderComponent>
        {children}
        <Loader />
      </ContextProviderComponent>
    </>
  );
};

export default Index;

export const Head = () => <></>;
